import styled from 'styled-components';
import { breakpoints } from 'config/config';

interface FarmGaleriesWrapperProps { }

export const FarmDeliveriesWrapper = styled.div<FarmGaleriesWrapperProps>`
  .custom-collapse {
    background: none;
    border-radius: 0;
    border: 0;
    font-family: ${(props) => props.theme.fontText};
  }

  .custom-collapse .ant-collapse-item:nth-child(odd) {
    background-color: ${(props) => props.theme.grayBg} !important;
  }

  .custom-collapse .ant-collapse-item:nth-child(even) {
    background-color: ${(props) => props.theme.white};
  }

  .custom-collapse .ant-collapse-item {
    border: 1px solid ${(props) => props.theme.whiteSmoke};
  }

  .custom-collapse .ant-collapse-header-text {
    font-size: 16px;
    font-weight: 600;
    color: ${(props) => props.theme.colorText};
  }

  .custom-collapse .ant-collapse-content {
    border: 0;
  }

  .custom-collapse > .ant-collapse-item:last-child {
    border-radius: 0;
  }

  .custom-collapse .ant-collapse-header {
    background: none;
    border-radius: 0;
    padding: 10px 20px 10px 20px;
  }

  .custom-collapse .ant-collapse-content-box {
    padding: 0px 20px 10px 20px;
  }

  .custom-collapse .ant-collapse-arrow {
    color: inherit;
  }

  .delivery-item-title {
    display: block;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 400;
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .ant-collapse-header-text {
      font-size: 1rem !important;
    }

    .working-time{
      .day-name{
        font-size: 1rem;
      }

      .day-time{
        font-size: 1rem;
      }
    }
  }
`;

export const DeliveryContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  .delivery-description {
    font-size: 16px;
    color: ${(props) => props.theme.colorText};
  }

  .delivery-price {
    font-size: 16px;
    font-weight: 500;
    color: ${(props) => props.theme.colorText};
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    font-size: 1rem;
  }

  @media (max-width: ${breakpoints.xs}px) {
    padding: 0 20px;

    &.farm-partner {
      padding: 23px 20px 46px 20px;
    }

    .custom-collapse .ant-collapse-content-box {
      padding: 0px 20px 10px 20px;
    }
  }
`;
